import { gql } from '@apollo/client';
import atlAppraiserInfoFragment from './atlAppraiserInfoFragment';

const GET_CURRENT_ATL = gql`
  query GetCurrentAtl {
    currentAtl {
      ...AtlAppraiserInfoFields
    }
  }

  ${atlAppraiserInfoFragment}
`;

export default GET_CURRENT_ATL;
